import JSEncrypt from 'jsencrypt';
import Apis from '@/api';

const states = {
  bodyMinHeight: 0,
  rules: {
    password: (opt) => {
      const req = opt.req || true;
      const min = opt.min || 8;
      const max = opt.max || 16;
      const reqMsg = opt.reqMsg || '请输入信息';
      const lengMsg = opt.reqMsg || (`长度需要${min}和${max}之间`);
      return [
        { required: req, message: reqMsg, trigger: 'blur' },
        {
          min, max, message: lengMsg, trigger: 'blur',
        },
      ];
    },
    adminAccount: (min = 1, max = 32, msg = '请输入信息') => [
      { required: true, message: msg, trigger: 'blur' },
      {
        min, max, message: `长度需要在${min}和${max}之间`, trigger: 'blur',
      },
    ],
    captcha: (min = 1, max = 32, msg = '请输入信息') => [
      { required: true, message: msg, trigger: 'blur' },
      {
        min, max, message: `长度需要在${min}和${max}之间`, trigger: 'blur',
      },
    ],
    mobile: (min = 1, max = 11, msg = '请输入信息', errMsg = '格式错误') => [
      { required: true, message: msg, trigger: 'blur' },
      {
        min, max, message: errMsg, trigger: 'blur',
      },
      {
        pattern: /^1\d{1,10}$/,
        message: errMsg,
        trigger: 'blur',
      },
    ],
    email: (min = 1, max = 255, msg = '请输入信息', errMsg = '格式错误') => [
      { required: true, message: msg, trigger: 'blur' },
      {
        min, max, message: errMsg, trigger: 'blur',
      },
      {
        pattern: /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i,
        message: errMsg,
        trigger: 'blur',
      },
    ],
  },
  headerClass: { immersive: false },
  publicKey: '',
};

const mutations = {
  SET_BODY_MIN_HEIGHT(state, val) {
    state.bodyMinHeight = val;
  },
  CHANGE_HEADER_TYPE(state, val) {
    let cls = {};
    switch (val) {
      case 'default':
        cls = { immersive: false };
        break;
      case 'immersive':
        cls = { immersive: true };
        break;
      default:
        cls = {};
    }
    state.headerClass = cls;
  },
  CHANGE_SECRET(state, val) {
    state.secret = val;
  },
};

const actions = {
  // 获取菜单数据
  setBodyMinHeight({ commit }, val) {
    commit('SET_BODY_MIN_HEIGHT', val);
  },
  getPublicKey({ commit }) {
    return Apis.getPublicKey().then((response) => {
      const publicKey = response.data;
      const ENCRYOTOR = new JSEncrypt();
      ENCRYOTOR.setPublicKey(publicKey);
      const pwd = val => ENCRYOTOR.encrypt(val);
      commit('CHANGE_SECRET', pwd);
      return response;
    });
  },
};

const getters = {

};

export default {
  namespaced: true,
  state: states,
  mutations,
  actions,
  getters,
};
